import anthropic from "./anthropic.js";
import { name as arizeName, provider as arizeProvider } from "./arize.js";
import auth0 from "./auth0.js";
import awsLambda from "./aws-lambda.js";
import { name as azureOpenAIName, provider as azureOpenAIProvider } from "./azure-openai.js";
import bigcommerce from "./bigcommerce.js";
import bigcommerceCatalog from "./bigcommerce-catalog.js";
import commercelayer from "./commercelayer.js";
import contentful from "./contentful.js";
import elasticpath from "./elasticpath.js";
import fauna from "./fauna.js";
import graphql from "./generic/graphql.js";
import openapi from "./generic/openapi.js";
import rest from "./generic/rest.js";
import { name as googleVertexName, provider as googleVertexProvider } from "./google-vertex.js";
import gorgias from "./gorgias.js";
import groq from "./groq.js";
import hygraph from "./hygraph.js";
import judgeMe from "./judge-me.js";
import klaviyo from "./klaviyo.js";
import loyaltylion from "./loyaltylion.js";
import mailchimp from "./mailchimp.js";
import netlify from "./netlify.js";
import notion from "./notion.js";
import oidc from "./oidc.js";
import { provider as olyslager } from "./olyslager/index.js";
import openai from "./openai.js";
import petfinder from "./petfinder.js";
import postscript from "./postscript.js";
import recharge from "./recharge.js";
import reviewsIo from "./reviews-io.js";
import riseAiCredit from "./rise-ai-credit.js";
import riseAiGifting from "./rise-ai-gifting.js";
import salsify from "./salsify.js";
import sanity from "./sanity.js";
import shipEngine from "./ship-engine.js";
import shopify from "./shopify.js";
import shopifyStorefront from "./shopify-storefront.js";
import stripe from "./stripe.js";
import submarine from "./submarine.js";
import { provider as syndigo } from "./syndigo/syndigo.js";
import unstructured from "./unstructured.js";
import vercel from "./vercel.js";
import voyageai from "./voyageai.js";
import wordpress from "./wordpress.js";
import yelp from "./yelp.js";
import yotpoLoyalty from "./yotpo-loyalty.js";
import yotpoUgc from "./yotpo-ugc.js";
export const providers = {
    vercel,
    netlify,
    shopify,
    shopifyStorefront,
    bigcommerce,
    bigcommerceCatalog,
    rest,
    graphql,
    petfinder,
    auth0,
    openapi,
    mailchimp,
    commercelayer,
    stripe,
    fauna,
    klaviyo,
    contentful,
    hygraph,
    awsLambda,
    notion,
    yelp,
    reviewsIo,
    judgeMe,
    shipEngine,
    oidc,
    elasticpath,
    loyaltylion,
    salsify,
    sanity,
    gorgias,
    yotpoUgc,
    yotpoLoyalty,
    postscript,
    riseAiCredit,
    riseAiGifting,
    recharge,
    wordpress,
    openai,
    voyageai,
    anthropic,
    submarine,
    [arizeName]: arizeProvider,
    [azureOpenAIName]: azureOpenAIProvider,
    [googleVertexName]: googleVertexProvider,
    unstructured,
    [syndigo.name]: syndigo,
    [olyslager.name]: olyslager,
    groq
};
export default providers;
